const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/asset-groups.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/asset-groups")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewClientData, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});